import { render, staticRenderFns } from "./_Despedida.vue?vue&type=template&id=25a18c58&scoped=true&"
import script from "./_Despedida.vue?vue&type=script&lang=js&"
export * from "./_Despedida.vue?vue&type=script&lang=js&"
import style0 from "./_Despedida.vue?vue&type=style&index=0&id=25a18c58&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25a18c58",
  null
  
)

export default component.exports